import * as actions from './actions'
import * as selectors from './selectors'
import reducer from './reducers'

export default {
  actions,
  reducer,
  selectors,
}
